// Enhanced script to handle dynamically loaded submenus with optimized performance
function addMenuClasses() {
    // console.log('=== Starting addMenuClasses ===');
    
    // Find all tmenu_wrapper containers
    const menuWrappers = document.querySelectorAll('.tmenu_wrapper');
    
    if (menuWrappers.length === 0) {
        return false;
    }
    
    let totalProcessed = 0;
    let totalUlsModified = 0;
    let totalLisModified = 0;
    
    // Get the monitoring set from our setup function (stored globally)
    const monitoredElements = window.menuClassMonitoredElements || new Set();
    
    // Process each menu wrapper
    menuWrappers.forEach((wrapper, wrapperIndex) => {
        // Find all "Shop By Specifications" links within this wrapper
        const shopBySpecsLinks = wrapper.querySelectorAll('a[title="Shop By Specifications"]');
  
        // Also find any links with "Essentials" in the title for featured-list processing
        const essentialsLinks = wrapper.querySelectorAll('a[title*="Essentials"]');
        // if(essentialsLinks){console.log('found');}
        // Also find any links with "Shop All" or "View All" in the title for shop-all-button processing
        const shopAllLinks = wrapper.querySelectorAll('a[title*="Shop All"], a[title*="View All"]');
        
        // Process all "Essentials" parent menu items
        essentialsLinks.forEach((essentialsLink, essIndex) => {
            const parentLi = essentialsLink.closest('li');
                //   console.log('=== ess ===');
            if (parentLi && !parentLi.classList.contains('featured-list')) {
                parentLi.classList.add('featured-list');
                monitoredElements.add(parentLi); // Track this element
                // console.log(`Added "featured-list" to parent <li> of "${essentialsLink.getAttribute('title')}" link`);
                totalLisModified++;
            }
        });
        
        // Process all "Shop All" or "View All" parent menu items
        shopAllLinks.forEach((shopAllLink, shopAllIndex) => {
            const parentLi = shopAllLink.closest('li');
            if (parentLi && !parentLi.classList.contains('shop-all-button')) {
                parentLi.classList.add('shop-all-button');
                monitoredElements.add(parentLi); // Track this element
                // console.log(`Added "shop-all-button" to parent <li> of "${shopAllLink.getAttribute('title')}" link`);
                totalLisModified++;
            }
        });
        
        shopBySpecsLinks.forEach((link, linkIndex) => {
            // console.log(`Processing "Shop By Specifications" link ${linkIndex + 1}`);
            
            // Get the parent <li> element
            const parentLi = link.closest('li');
            if (!parentLi) {
                return;
            }
            
            // Find all submenu <ul> elements
            const submenuUls = parentLi.querySelectorAll('ul');
            
            submenuUls.forEach((ul, ulIndex) => {
                // Add "spec-list" class
                if (!ul.classList.contains('spec-list')) {
                    ul.classList.add('spec-list');
                    monitoredElements.add(ul); // Track this element
                    totalUlsModified++;
                }
                
                // Add "spec-item" or "spec-header" class to immediate <li> children
                const immediateLiChildren = ul.querySelectorAll(':scope > li');
                
                immediateLiChildren.forEach((li, liIndex) => {
                    let classAdded = false;
                    
                    // Check if this <li> has the "tmenu_item_display_header" class
                    if (li.classList.contains('tmenu_item_display_header') && !li.classList.contains('spec-header')) {
                        li.classList.add('spec-header');
                        monitoredElements.add(li); // Track this element
                        classAdded = true;
                    } else if (!li.classList.contains('tmenu_item_display_header') && !li.classList.contains('spec-item')) {
                        li.classList.add('spec-item');
                        monitoredElements.add(li); // Track this element
                        classAdded = true;
                    }
                    
                    // Check if this <li> contains an <a> with "Essentials" in the title
                    const essentialsLink = li.querySelector('a[title*="Essentials"]');
                    if (essentialsLink && !li.classList.contains('featured-list')) {
                        li.classList.add('featured-list');
                        monitoredElements.add(li); // Track this element
                        // console.log(`Added "featured-list" to <li> ${liIndex + 1} (contains "Essentials" link: "${essentialsLink.getAttribute('title')}")`);
                    }
                    
                    // Check if this <li> contains an <a> with "Shop All" or "View All" in the title
                    const shopAllLink = li.querySelector('a[title*="Shop All"], a[title*="View All"]');
                    if (shopAllLink && !li.classList.contains('shop-all-button')) {
                        li.classList.add('shop-all-button');
                        monitoredElements.add(li); // Track this element
                        // console.log(`Added "shop-all-button" to <li> ${liIndex + 1} (contains "Shop All/View All" link: "${shopAllLink.getAttribute('title')}")`);
                    }
                    
                    if (classAdded) {
                        totalLisModified++;
                    }
                });
            });
            
            totalProcessed++;
        });
    });
    
    // Store monitored elements globally for access by the observer
    window.menuClassMonitoredElements = monitoredElements;
    
    // console.log(`=== Results: Processed ${totalProcessed} instances, modified ${totalUlsModified} <ul>s and ${totalLisModified} <li>s ===`);
    return totalProcessed > 0;
}

// Function to set up efficient monitoring for class persistence
function setupContinuousMonitoring() {
    // console.log('=== Setting up optimized monitoring ===');
    
    let processedCount = 0;
    let lastProcessTime = 0;
    const THROTTLE_DELAY = 100; // Throttle rapid-fire changes
    
    // Keep track of elements we're monitoring to avoid unnecessary checks
    const monitoredElements = new Set();
    
    function throttledAddMenuClasses() {
        const now = Date.now();
        if (now - lastProcessTime < THROTTLE_DELAY) {
            return; // Skip if called too frequently
        }
        lastProcessTime = now;
        
        // console.log('Running throttled class reapplication');
        const result = addMenuClasses();
        if (result) {
            processedCount++;
        }
    }
    
    // More targeted MutationObserver - only watch menu containers
    const observer = new MutationObserver((mutations) => {
        let shouldCheck = false;
        
        mutations.forEach((mutation) => {
            // Only process if the change is within a menu container
            const isInMenu = mutation.target.closest('.tmenu_wrapper, .tmenu_submenu') !== null;
            if (!isInMenu) return;
            
            // Check for new nodes that might need processing
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (node.querySelector && 
                        (node.querySelector('a[title="Shop By Specifications"]') || 
                         node.querySelector('a[title*="Essentials"]') ||
                         node.querySelector('a[title*="Shop All"], a[title*="View All"]') ||
                         node.classList?.contains('tmenu_submenu'))) {
                        shouldCheck = true;
                    }
                }
            });
            
            // Check for class attribute changes, but only on our monitored elements
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                if (monitoredElements.has(target)) {
                    // console.log('Detected class change on monitored element, scheduling recheck');
                    shouldCheck = true;
                }
            }
        });
        
        if (shouldCheck) {
            throttledAddMenuClasses();
        }
    });
    
    // Only observe menu containers, not the entire document
    document.querySelectorAll('.tmenu_wrapper').forEach(wrapper => {
        observer.observe(wrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    });
    
    // Fallback observer for new menu wrappers
    const documentObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE && 
                    (node.classList?.contains('tmenu_wrapper') || node.querySelector?.('.tmenu_wrapper'))) {
                    // console.log('New menu wrapper detected, adding to monitoring');
                    observer.observe(node, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['class']
                    });
                }
            });
        });
    });
    
    documentObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Much less frequent periodic check as final safety net
    const periodicCheck = setInterval(() => {
        // Only run if we haven't processed recently
        if (Date.now() - lastProcessTime > 5000) { // 5 seconds since last check
            const essentialsLinks = document.querySelectorAll('a[title*="Essentials"]');
            const shopAllLinks = document.querySelectorAll('a[title*="Shop All"], a[title*="View All"]');
            let needsCheck = false;
            
            // Quick check - just verify a few key elements
            essentialsLinks.forEach(essentialsLink => {
                const parentLi = essentialsLink.closest('li');
                if (parentLi && !parentLi.classList.contains('featured-list')) {
                    needsCheck = true;
                }
            });
            
            shopAllLinks.forEach(shopAllLink => {
                const parentLi = shopAllLink.closest('li');
                if (parentLi && !parentLi.classList.contains('shop-all-button')) {
                    needsCheck = true;
                }
            });
            
            if (needsCheck) {
                // console.log('Periodic safety check found missing classes');
                throttledAddMenuClasses();
            }
        }
    }, 5000); // Only check every 5 seconds as a safety net
    
    // Stop periodic checks after 5 minutes to avoid infinite running
    setTimeout(() => {
        clearInterval(periodicCheck);
        // console.log('Stopped periodic safety checks after 5 minutes');
    }, 300000);
    
    // console.log('Optimized monitoring active - watching menu containers only');
    
    return { observer, documentObserver, periodicCheck, monitoredElements };
}

// Function to trigger submenus (in case they need to be activated)
function triggerSubmenus() {
    // console.log('=== Attempting to trigger submenus ===');
    
    // Look for main menu items that might contain the "Shop By Specifications" submenu
    const potentialParents = document.querySelectorAll('a[title="Safety Air Guns"], .lv1-safety-air a, a[title*="Air Gun"]','a[title="Pneumatic Vacuums"]');
    // console.log(`Found ${potentialParents.length} potential parent menu items`);
    
    potentialParents.forEach((parent, index) => {
        // console.log(`Checking parent ${index + 1}: ${parent.getAttribute('title') || parent.textContent}`);
        // console.log('parent');
        // Try hovering to trigger submenu
        parent.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true }));
        parent.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
        
        // Also try clicking if it has href="javascript:;"
        if (parent.getAttribute('href') === 'javascript:;') {
            parent.click();
        }
    });
    
    // Give a moment for submenus to load, then check
    setTimeout(() => {
        // console.log('Checking for "Shop By Specifications" after triggering submenus...');
        addMenuClasses();
    }, 500);
}

// Main initialization
function initialize() {
    // console.log('=== Initializing menu class script ===');
    
    // First, look for tmenu_wrapper
    const menuWrappers = document.querySelectorAll('.tmenu_wrapper');
    // console.log(`Found ${menuWrappers.length} menu wrappers`);
    
    if (menuWrappers.length === 0) {
        // console.log('No menu wrappers found, will wait...');
        setTimeout(initialize, 500);
        return;
    }
    
    // Try immediate processing
    // console.log('Menu wrappers found, attempting immediate processing...');
    const immediateResult = addMenuClasses();
    
    if (!immediateResult) {
        // console.log('No "Shop By Specifications" links found initially, trying to trigger submenus...');
        triggerSubmenus();
        
        // Start continuous monitoring for dynamically loaded content
        setupContinuousMonitoring();
    } else {
        // console.log('Successfully processed immediately!');
        // Still set up monitoring in case there are more instances that load later
        setupContinuousMonitoring();
    }
}

// Start when DOM is ready
// console.log('=== Menu class script loaded ===');
// console.log('Document ready state:', document.readyState);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
} else {
    initialize();
}